import { API } from "../urls";

// Cookie-based auth: credentials: 'include' ile access_token cookie otomatik gönderilir
const getHeaders = () => ({
    "Content-Type": "application/json",
});

// Dosya yüklemede Content-Type tarayıcı tarafından (boundary ile) otomatik set edilir
const getFileHeaders = () => ({});

const fetchOpts = { credentials: 'include' };

export const fetchCompanySettings = async (companyId) => {
    const res = await fetch(API.company_settings(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const updateCompanySettings = async (companyId, data) => {
    const res = await fetch(API.company_settings(companyId), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const uploadCompanyImage = async (companyId, type, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const url = type === 'logo' ? API.company_logo(companyId) : API.company_favicon(companyId);

    const res = await fetch(url, {
        method: "POST",
        ...fetchOpts,
        headers: getFileHeaders(),
        body: formData,
    });
    return res;
};

// Firma logosu/faviconu sil. Sunucu hem dosyayı hem kayıttaki yolu temizler;
// panel tarafında yalnız state temizlemek yeterli değildi çünkü görsel klasörden
// servis ediliyor ve sayfa yenilenince geri geliyordu.
export const deleteCompanyImage = async (companyId, type) => {
    const url = type === 'logo' ? API.company_logo(companyId) : API.company_favicon(companyId);

    const res = await fetch(url, {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res;
};

export const fetchSampleContract = async (type, companyId) => {
    const res = await fetch(API.get_sample_contract(type, companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const fetchVPOSSettings = async (companyId) => {
    const res = await fetch(API.vpos_settings_company(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const upsertVPOSSettings = async (data) => {
    const res = await fetch(API.vpos_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const fetchGroups = async (companyId) => {
    const res = await fetch(API.groups_by_company(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

/**
 * Sayfalı grup listesi — süper adminin tüm firmaları tek listede görmesi için.
 * `fetchGroups` tek firmaya bağlıdır ve sayfalama yapmaz; firma sayısı arttıkça
 * hepsini tek seferde çekmek sürdürülebilir değil.
 */
export const fetchGroupsPage = async ({ page, size, searchTerm, companyId, sort } = {}) => {
    const res = await fetch(API.account_groups_page({ page, size, searchTerm, companyId, sort }),
        { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const deleteGroup = async (groupId) => {
    return fetch(API.deleteGroup(groupId), { method: "DELETE", ...fetchOpts, headers: getHeaders() });
};

/**
 * Paket ödemesinde kullanılacak taksit grubunu açar/kapatır (yalnız SUPER_ADMIN).
 * Açmak, varsa önceki grubun işaretini backend'de düşürür — tek çağrı yeterli.
 */
export const setSubscriptionGroup = async (groupId, enabled) => {
    const res = await fetch(API.setSubscriptionGroup(groupId, enabled), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const saveGroup = async (groupData, isEdit) => {
    const { id, ...payload } = groupData;
    const url = isEdit ? API.updateGroup(id) : API.createGroup();

    const res = await fetch(url, {
        method: isEdit ? "PUT" : "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });

    const result = await res.json();
    if (!res.ok) {
        throw new Error(result.message || "Bir hata oluştu");
    }

    return result;
};

export const fetchPayTRRates = async (companyId) => {
    const res = await fetch(API.getInstallmentRates(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const changePassword = async (data) => {
    const res = await fetch(API.change_password, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const fetchCurrentUser = async () => {
    const res = await fetch(API.auth_me, { ...fetchOpts, headers: getHeaders() });
    return res;
};

export const fetchParamPOSSettings = async (companyId) => {
    const res = await fetch(API.param_vpos_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const upsertParamPOSSettings = async (data) => {
    const res = await fetch(API.param_vpos_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const fetchEsnekPosSettings = async (companyId) => {
    const res = await fetch(API.esnekpos_vpos_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const fetchQnbPOSSettings = async (companyId) => {
    const res = await fetch(API.qnb_vpos_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const upsertEsnekPosSettings = async (data) => {
    const res = await fetch(API.esnekpos_vpos_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const upsertQnbPOSSettings = async (data) => {
    const res = await fetch(API.qnb_vpos_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const fetchIsyerimPosSettings = async (companyId) => {
    const res = await fetch(API.isyerimpos_vpos_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

/** İşyerimPOS üye iş yeri başvuru formunun firma kaydından doldurulan alanları. */
export const fetchIsyerimPosApplicationDefaults = async (companyId) => {
    const res = await fetch(API.isyerimpos_application_defaults(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

/** İşyerimPOS üye iş yeri başvurusunu gönderir; yanıt gövdesi statusCode + message taşır. */
export const submitIsyerimPosApplication = async (companyId, data) => {
    const res = await fetch(API.isyerimpos_application(companyId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const upsertIsyerimPosSettings = async (data) => {
    const res = await fetch(API.isyerimpos_vpos_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

export const deleteIsyerimPosSettings = async (id) => {
    const res = await fetch(API.isyerimpos_vpos_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const fetchGarantiPOSSettings = async (companyId) => {
    const res = await fetch(API.garanti_vpos_settings_company(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const upsertGarantiPOSSettings = async (data) => {
    const res = await fetch(API.garanti_vpos_settings_upsert, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res.json();
};

// Sanal POS ayarı silme (bağlantıyı kaldırma) — backend DELETE /{id} döner: { statusCode, data: true }
export const deleteParamPOSSettings = async (id) => {
    const res = await fetch(API.param_vpos_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const deleteEsnekPosSettings = async (id) => {
    const res = await fetch(API.esnekpos_vpos_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const deleteQnbPOSSettings = async (id) => {
    const res = await fetch(API.qnb_vpos_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const deleteGarantiPOSSettings = async (id) => {
    const res = await fetch(API.garanti_vpos_settings_delete(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const fetchActivePosByCompany = async (companyId) => {
    const res = await fetch(API.active_pos_company(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const fetchActiveBankBrands = async (companyId) => {
    const res = await fetch(API.active_bank_brands(companyId), {
        method: "GET",
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

export const migrateBrandToVirtualPos = async (companyId, { cardBrand, virtualPos }) => {
    const res = await fetch(API.active_pos_migrate_brand(companyId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ cardBrand, virtualPos }),
    });
    return res.json();
};

/**
 * Bağlantısı kaldırılmış bir POS'ta kalan kart markaları ve aktarım için uygun
 * (gerçekten kurulu) POS'lar. Bağlantı kaldırıldıktan sonra sorulan
 * "markaları X'e aktaralım mı?" penceresi bunu kullanır.
 */
export const getActivePosOrphanSummary = async (companyId) => {
    const res = await fetch(API.active_pos_orphan_summary(companyId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

/** Bir POS'un tüm kart markalarını başka bir POS'a taşır. */
export const migrateAllBrandsToVirtualPos = async (companyId, { sourceVirtualPos, targetVirtualPos }) => {
    const res = await fetch(API.active_pos_migrate_pos(companyId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ sourceVirtualPos, targetVirtualPos }),
    });
    return res.json();
};

export const refreshBrandInstallments = async (companyId, cardBrand) => {
    const res = await fetch(API.active_pos_refresh_brand(companyId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ cardBrand }),
    });
    return res.json();
};

export const setActivePosStandart = async (companyId, enabled) => {
    const res = await fetch(API.active_pos_standart(companyId), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ enabled }),
    });
    return res.json();
};

// Firma logo getir (blob)
export const fetchCompanyLogo = async (companyId) => {
    const res = await fetch(API.company_logo(companyId), { ...fetchOpts });
    return res;
};

// Firma favicon getir (blob)
export const fetchCompanyFavicon = async (companyId) => {
    const res = await fetch(API.company_favicon(companyId), { ...fetchOpts });
    return res;
};

// Firma listesi (admin)
export const fetchCompaniesList = async () => {
    const res = await fetch(API.companies_list, { ...fetchOpts });
    return res;
};

// Admin firma detay
export const fetchAdminCompany = async (companyId) => {
    const res = await fetch(API.admin_company(companyId), { ...fetchOpts, headers: getHeaders() });
    return res;
};

// Firma logosu. Uç anonim erişime açık ama OTURUM VARSA firmayı token'dan çözüyor;
// bu yüzden credentials ŞART. Gönderilmezse (yerelde panel :3000, API :8080 → çapraz
// köken) cookie hiç gitmiyor, backend anonim sanıp alan adına düşüyor ve süper admin
// "kullanıcıya geç" yaptığında hedef firmanın değil platformun logosu geliyordu.
export const fetchPublicCompanyLogo = async () => {
    const res = await fetch(API.get_company_logo, { ...fetchOpts });
    return res;
};

// Aynı gerekçe: favicon da oturumdaki firmaya göre dönmeli.
export const fetchPublicCompanyFavicon = async () => {
    const res = await fetch(API.get_company_favicon, { ...fetchOpts });
    return res;
};

// VPOS ayarları getir (companyCode query param ile)
export const fetchVPOSByCompany = async (companyId, companyCode) => {
    const res = await fetch(`${API.get_vpos_by_company(companyId)}?companyCode=${encodeURIComponent(companyCode)}`, {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res.json();
};

// VPOS ayarları kaydet (POST to get_vpos_settings)
export const saveVPOSSettings = async (data) => {
    const res = await fetch(API.get_vpos_settings, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return res;
};

// Firma isimleri getir (companies/names)
export const fetchCompanyNames = async () => {
    const res = await fetch(API.get_companies_names, { ...fetchOpts });
    return res;
};

// Firma bilgisi domain bazlı
export const fetchCompanyInfoByDomain = async () => {
    const res = await fetch(API.get_company_info_by_domain, {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res;
};
